module.exports = __webpack_public_path__ + "static/media/main-business-02.7294cbd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-business-02.mp4
// module id = O4u+
// module chunks = 1